import React from "react";
import { Outlet } from "react-router-dom";

export default function PublicLayout({ openLoginModal = () => {} }) {
  return (
    <div className="h-screen overflow-hidden bg-white text-slate-900 pt-[64px]">
      <div className="h-[calc(100vh-64px)] overflow-y-auto">
        <Outlet context={{ openLoginModal }} />
      </div>
    </div>
  );
}
